// CollapsibleComponent.js
import React, { useState } from "react";
import "./Collapsible.css";

const CollapsibleContainer = ({
  label,
  children,
  direction = "vertical",
  side = "left",
  initialCollapsed = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(initialCollapsed);

  // Determine classes based on direction and collapsed state
  const getContainerClass = () => {
    if (direction === "horizontal") {
      return `narrow-pane ${side} ${isCollapsed ? "h-collapsed" : "h-expanded"} ${
        isCollapsed && side === "right" ? "h-collapsed-right" : ""
      }`;
    }
    return "";
  };

  const getButtonClass = () => {
    if (direction === "horizontal") {
      return `h-collapsible ${side} ${!isCollapsed ? "open" : ""}`;
    }
    return `collapsible ${isCollapsed ? "closed" : "open"}`;
  };

  // For horizontal collapsing
  if (direction === "horizontal") {
    return (
      <div className={getContainerClass()} style={{ display: "flex" }}>
        {isCollapsed && (
          <button
            className={getButtonClass()}
            onClick={() => setIsCollapsed(false)}
            aria-expanded={!isCollapsed}
            aria-controls="collapsible-content"
          >
            {label}
          </button>
        )}
        <div
          style={{
            flex: 1,
            display: isCollapsed ? "none" : "block",
            width: "100%",
          }}
        >
          <div className="pane-title-bar">
            <button
              className={getButtonClass()}
              onClick={() => setIsCollapsed(true)}
              aria-expanded={!isCollapsed}
              aria-controls="collapsible-content"
            >
              {label}
            </button>
          </div>
          <div data-dev="pane-content" className="flex-column">
            {children}
          </div>
        </div>
      </div>
    );
  }

  // For vertical collapsing (original behavior)
  return (
    <div>
      <button
        className={`${getButtonClass()}${!isCollapsed ? " sticky" : ""}`}
        type="button"
        onClick={() => setIsCollapsed(!isCollapsed)}
        aria-expanded={!isCollapsed}
        aria-controls="collapsible-content"
      >
        {label}
      </button>
      <div style={{ display: isCollapsed ? "none" : "block" }}>{children}</div>
    </div>
  );
};

export default CollapsibleContainer;
